import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import zh from "./locales/zh.json";
import ja from "./locales/ja.json";
import ru from "./locales/ru.json";
import id from "./locales/id.json";
import ms from "./locales/ms.json";
import sw from "./locales/sw.json";
import ta from "./locales/ta.json";
import { DEFAULT_LOCALE } from "./config";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            ar: { translation: ar },
            fr: { translation: fr },
            de: { translation: de },
            zh: { translation: zh },
            ja: { translation: ja },
            ru: { translation: ru },
            id: { translation: id },
            ms: { translation: ms },
            sw: { translation: sw },
            ta: { translation: ta },
        },
        lng: DEFAULT_LOCALE,
        fallbackLng: DEFAULT_LOCALE,
        interpolation: { escapeValue: false },
        react: { useSuspense: false },
    });

export default i18n;
